const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class InternationalAgreement extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.InternationalAgreement,
            "The strongest civilization may immediately take up to 5 civil action in cards by giving up its next chance to take a political action. Replenish the card row. This may end the Age.",
            {}
        )
    }
}

module.exports = InternationalAgreement;